@if (show) {
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="header-main">
        <div class="header-icon-container">
          <fa-icon [icon]="faPlay"></fa-icon>
        </div>
        <div class="header-titles">
          <h3>{{ 'EXECUTE_MODAL.TITLE' | translate }}</h3>
          <p>{{ 'EXECUTE_MODAL.DESCRIPTION' | translate }}</p>
        </div>
      </div>
      <button class="close-btn" type="button" (click)="onClose()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>

    <div class="modal-body">
      <div class="options-grid">

        <div class="options-section">
          <div class="section-header">
            <span class="section-title">{{ 'SETTINGS.PREFERENCES.DEFAULT_CONFIGS' | translate }}</span>
          </div>

          <div class="config-fields-group">
            @if (showDelfosServer) {
            <div class="config-field">
              <label>{{ 'SETTINGS.PREFERENCES.DELFOS_SERVER' | translate }}</label>
              <ng-select
                [items]="delfosServerConfigs"
                bindLabel="display_label"
                bindValue="id"
                [(ngModel)]="options.delfos_server_config_id"
                [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false">
              </ng-select>
            </div>
            }

            <div class="config-field">
              <label>{{ 'SETTINGS.PREFERENCES.DELFOS_LLM' | translate }}</label>
              <ng-select
                [items]="delfosLlmConfigs"
                bindLabel="display_label"
                bindValue="id"
                [(ngModel)]="options.delfos_llm_config_id"
                [placeholder]="'SETTINGS.PREFERENCES.SELECT_CONFIG' | translate"
                [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
                [clearable]="true"
                [searchable]="false">
              </ng-select>
            </div>
          </div>
        </div>

        <div class="options-section secondary">
          <div class="section-header">
            <span class="section-title">{{ 'SETTINGS.PREFERENCES.CACHE_OPTIONS' | translate }}</span>
          </div>

          <div class="config-field language-field">
            <label>{{ 'SETTINGS.PREFERENCES.AI_MODEL_LANGUAGE' | translate }}</label>
            <ng-select
              [items]="aiModelLanguageOptions"
              bindLabel="label"
              bindValue="value"
              [(ngModel)]="options.ai_model_language"
              [clearable]="false"
              [searchable]="false"
              [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate">
              <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
              <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
            </ng-select>
          </div>

          <div class="cache-toggle-grid">
            <div class="checkbox-item" [class.active]="options.clear_delfos_cache"
              (click)="toggleOption('clear_delfos_cache')">
              <div class="checkbox-control">
                <fa-icon [icon]="options.clear_delfos_cache ? faToggleOn : faToggleOff"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'EXECUTE_MODAL.CLEAR_RESPONSE_CACHE' | translate }}</span>
            </div>
          </div>

          <div class="save-preference-wrapper">
            <div class="checkbox-item save-as-default" [class.active]="options.save_as_default"
              (click)="toggleOption('save_as_default')">
              <div class="checkbox-control">
                <fa-icon [icon]="options.save_as_default ? faCheckSquare : faSquare"></fa-icon>
              </div>
              <span class="checkbox-label">{{ 'EXECUTE_MODAL.SAVE_AS_DEFAULT' | translate }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="modal-footer">
      <app-button [text]="'EXECUTE_MODAL.CANCEL' | translate" variant="secondary" (clicked)="onClose()">
      </app-button>
      <app-button [text]="'EXECUTE_MODAL.EXECUTE' | translate" variant="primary" [icon]="faPlay"
        (clicked)="onConfirm()">
      </app-button>
    </div>
  </div>
</div>
}
